import { navigate } from '@reach/router';
import IconChecklist_1 from 'assets/svg/icons/home/checklist-1.inline.svg';
import IconChecklist_2 from 'assets/svg/icons/home/checklist-2.inline.svg';
import IconChecklist_3 from 'assets/svg/icons/home/checklist-3.inline.svg';
import IconFinance from 'assets/svg/icons/home/finance.inline.svg';
import IconTechnology from 'assets/svg/icons/home/technology.inline.svg';
import Panel from 'components/Molecules/Panel';
import { routes } from 'constants/routes';
import React from 'react';

export default function OurFlowPanel() {
	const handleScrollToBottom = () => {
		const element = document.querySelector('.index-scroll-view');
		element.scrollIntoView({behavior: 'smooth'});
	};

	return (
		<div className='flex flex-col items-center justify-center'>
			<Panel onClick={() => navigate(routes.PRODUCTS)} firstPanel Icon={IconChecklist_3} title='Krok 1' subtitle='Wybierz produkt' />
			<Panel onClick={() => navigate(routes.OFFERS)} Icon={IconTechnology} title='Krok 2' subtitle='Sprawdź ofertę' />
			<Panel onClick={() => navigate(routes.CONCLUSIONS)} Icon={IconChecklist_1} title='Krok 3' subtitle='Wypełnij wniosek' />
			<Panel Icon={IconChecklist_2} title='Krok 4' subtitle='Podpisz umowę' />
			<Panel onClick={handleScrollToBottom} lastPanel Icon={IconFinance} title='Krok 5' subtitle='Masz już umowę, a Twoi kontrahenci wiedzą o cesji? Prześlij nam dokumenty do wykupu, resztę zrobimy za Ciebie!' />
		</div>
	);
}
